<template>
    <b-modal v-model="viewerConfirm" size="lg" title="影片檢視器" ok-only>
        <template #modal-header>
        {{ viewer.title }}
        </template>
        <template #modal-footer>
        <button
            class="btn btn-success btn-sm m-1"
            @click="hideViewerVideo()"
        >
            關閉
        </button>
        </template>
        <iframe width="100%" height="400" 
            :src="viewer.url" :title="viewer.title + ' YouTube 播放器'" 
            frameborder="0" 
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            referrerpolicy="strict-origin-when-cross-origin" 
            allowfullscreen>{{ viewer.title + ' YouTube 播放器' }}</iframe>
    </b-modal>
</template> 
<script>
export default{
    data(){
        return {
            //是否開啟影片播放視窗
            viewerConfirm: false,
        };
    },
    props:["viewer"],
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "viewer"(){
            //初始化
            this.init();
        }
    },
    methods:{
        init(){
            console.log (this.viewer);
            this.viewerConfirm = this.viewer.confirm;
        },
        hideViewerVideo() {
            this.viewerConfirm = false;
            
            this.$emit('closeModal', this.viewer);
        },
    }
}
</script>